import React, {useEffect, useState} from "react";
import Badge from "@material-ui/core/Badge";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { firebaseConfig as firebase } from "../firebase"
import "firebase/database"

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

function AvatarBadge({ children, userId, ...props }) {
  const [userActive, setUserActive] = useState(false)
  const dbRef = firebase.database()
  const classes = useStyles();

  useEffect(() => {
    dbRef.ref(`userstatus/${userId}`).on("value", (snapshot) => {
      const status = snapshot.val()
      if (status === "online") {
        setUserActive(true)
      } else {
        setUserActive(false)
      }
    })
  },[])

  return (
    <div className={classes.root}>
      {userActive ? (
        <StyledBadge
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          variant="dot"
        >
          <Avatar {...props} >{children}</Avatar>
        </StyledBadge>
      ) : (
        <Avatar {...props} >{children}</Avatar>
      )}
    </div>
  );
}

export default AvatarBadge;